




















import useEmailStatusFilters from "@/composables/v2.1/useEmailStatusFilters";
import { useInboxModuleType } from "@/composables/v2.1/useInboxModuleType";
import { StatusFilterNameType } from "@/types/filter.types";
import numberLimiter from "@/utils/numberLimiter.util";
import { ReadDto } from "@saysimple-platform/dtos";
import { computed } from "@vue/composition-api";
import { BBadge, BNav, BNavItem } from "bootstrap-vue";

export default {
    components: {
        BNav,
        BNavItem,
        BBadge,
    },
    props: {
        activeFilter: {
            required: true,
        },
    },
    setup() {
        const { inboxModuleType } = useInboxModuleType();
        const { statusFilters, resolveUnreadChatStatusFilter, filterUnreadChats } = useEmailStatusFilters();

        const computedUnreadCounters = computed(() => {
            return filterUnreadChats(inboxModuleType.value).reduce(
                (filterResult: { [key in StatusFilterNameType]: ReadDto[] }, unreadChat: ReadDto) => {
                    resolveUnreadChatStatusFilter(unreadChat).forEach((statusFilterNameType: StatusFilterNameType) => {
                        filterResult[statusFilterNameType].push(unreadChat);
                    });

                    return filterResult;
                },
                {
                    [StatusFilterNameType.NEW]: [],
                    [StatusFilterNameType.OPEN]: [],
                    [StatusFilterNameType.TEAM]: [],
                    [StatusFilterNameType.PERSONAL]: [],
                    [StatusFilterNameType.ARCHIVE]: [],
                }
            );
        });

        return {
            computedUnreadCounters,
            statusFilters,
            numberLimiter,
        };
    },
};
